exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ":host div.row{margin-top:20px}:host div.row fieldset{width:100%}:host div.row legend{font-family:Perpetua;font-size:2rem}:host a{color:#005092;font-weight:600;text-decoration:underline}:host .warning_franceConnect{line-height:1.6rem;border-radius:2px;margin:2rem 0}:host .warning_franceConnect p{margin:.5rem 0}:host .warning_franceConnect ul li:before{content:\"-\";line-height:1.6rem;margin-left:1rem;padding-right:.5rem}:host hr{border-top:1px solid #000}:host .en_savoir_plus{color:#9b8c8c;text-decoration:none;font-family:Open Sans,sans-serif;font-size:.8rem;line-height:1rem;display:block;margin:auto}:host .en_savoir_plus a{color:#9b8c8c;text-decoration:underline}:host jhi-button[cancellation]{float:left}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["./~/bootstrap/scss/_functions.scss","./~/bootstrap/scss/_variables.scss","./src/main/webapp/content/scss/variables.scss"]}!./src/main/webapp/app/account/register/personne-physique/personne-physique.component.scss
// module id = 662
// module chunks = 0